var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TaskTemplateMultiSelect } from '../multiselect/TaskTemplateMultiSelect';
export var FilterTaskTemplateMultiSelect = function (_a) {
    var _b;
    var item = _a.item, clearItems = _a.clearItems, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(TaskTemplateMultiSelect, { selection: (_b = activeFilters[item]) !== null && _b !== void 0 ? _b : [], onChange: function (value) {
                var _a, _b;
                return setFilter((clearItems && (!value || value.length !== 1)
                    ? __assign((_a = {}, _a[item] = value !== null && value !== void 0 ? value : [], _a), clearItems.reduce(function (prev, clearItem) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[clearItem] = undefined, _a)));
                    }, {})) : (_b = {}, _b[item] = value !== null && value !== void 0 ? value : [], _b)));
            }, placeholder: undefined })),
    });
};
